import dayjs, { Dayjs } from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(localizedFormat)

type RelativeUnit = 'minute' | 'minutes' | 'hour' | 'hours'

const uaRelative = (value: number, unit: RelativeUnit): string => {
    const map: Record<RelativeUnit, string> = {
        minute: `${value}хв тому`,
        minutes: `${value}хв тому`,
        hour: `${value}г тому`,
        hours: `${value}г тому`,
    }

    return map[unit]
}

export const formatTime = (createdAt?: string | Date | Dayjs | null): string => {
    if (!createdAt) return ''

    const now = dayjs()
    const date = dayjs(createdAt)

    if (!date.isValid()) return ''

    const diffMinutes = now.diff(date, 'minute')
    const diffHours = now.diff(date, 'hour')

    // Межі беремо за календарними днями, як у getDayLabel: під розділювачем «Вчора»
    // не має бути «8г тому», а під датою — «вчора»
    if (date.isSame(now, 'day')) {
        if (diffMinutes < 1) return 'Зараз'
        if (diffMinutes < 60) return uaRelative(diffMinutes, 'minutes')
        return uaRelative(diffHours, 'hours')
    }

    if (date.isSame(now.subtract(1, 'day'), 'day')) return `вчора, ${date.format('HH:mm')}`

    return date.format('DD.MM.YYYY')
}
